(ns ui.view.screening.screening-profile-info-table.view
  (:require
   [common.localization :as loc]
   [frontend.routing :as routing]
   [ui.util :as uu]
   [ui.components.radix-ui.tooltip.view :as tooltip]
   [ui.view.screening.screening-profile-info-table.model :as model]))

(defn header-row
  [{:keys [label]}]
  [:tr
   [:td
    {:class    "px-3 py-2 border border-t-0 border-r-0 first:border-l-0 font-semibold bg-base-regular"
     :col-span 2}
    [:p label]]])

(defn info-row
  [{:keys [label last-row?]}]
  [:tr
   [:td
    {:class    (uu/cm "px-3 py-2 border border-t-0 border-r-0 first:border-l-0 text-base-light-text-paler text-sm m-0"
                      (when last-row?
                        "border-b-0"))
     :col-span 2}
    [:p label]]])

(defn key-value-row
  [{:keys [label value tooltip href end-icon-class last-row?]}]
  (let [value-el
        (cond href
              [:a
               {:href   href
                :target "_blank"}
               value]

              :else
              [:div
               {:class "flex items-center gap-1.5"}
               value
               (when end-icon-class
                 [:i {:class (uu/cm end-icon-class)}])])]
    [:tr
     [:td
      {:class (uu/cm "px-3 py-2 border border-t-0 border-r-0 first:border-l-0 text-semibold text-sm m-0 w-1/3"
                     (when last-row?
                       "border-b-0"))}
      label]
     [:td
      {:class (uu/cm "px-3 py-2 border border-t-0 border-r-0 first:border-l-0"
                     (when last-row?
                       "border-b-0"))}
      (if tooltip
        [tooltip/view
         {:side-offset 3}
         value-el
         [:span tooltip]]
        value-el)]]))

(defn pep-label-el
  [{:keys [pep? pep-or-rca-in-screening-service?]}]
  (let [pep-label (if pep?
                    (loc/tr :true)
                    (loc/tr :false))
        differs-from-screening-service? (or (and pep? (not pep-or-rca-in-screening-service?))
                                            (and (not pep?) pep-or-rca-in-screening-service?))]
    [:div
     {:class "flex justify-start"}
     [:div
      {:class (uu/cm "flex items-center gap-3"
                     (when differs-from-screening-service?
                       "px-3 py-1 rounded-full border bg-warning-light border-warning-regular"))}
      [:span
       {:class (uu/cm (when differs-from-screening-service?
                        "text-warning-light-text-accent"))}
       pep-label]
      (when differs-from-screening-service?
        [:div
         {:class "flex items-center gap-1 text-warning-light-text"}
         [:i {:class "fal fa-arrow-right text-sm m-0 font-medium"}]
         [:p
          {:class "text-sm m-0"}
          (loc/tr :differs-from-screening)]])]]))

(defn kyc-profiles-rows
  [{:keys [kyc-profiles-and-pep-statuses pep-or-rca-in-screening-service? person? last-row? open-entity!]}]
  (let [last-item-index (-> kyc-profiles-and-pep-statuses
                            count
                            dec)]
    [:<>
     [:tr
      [:td
       {:class    "px-3 py-2 bg-base-regular border border-t-0 border-r-0 first:border-l-0 font-semibold text-sm m-0"
        :col-span (if person? "1" "2")}
       (loc/tr :kyc-profile-name)]
      (when person?
        [:td
         {:class "px-3 py-2 bg-base-regular border border-t-0 border-r-0 first:border-l-0 font-semibold text-sm m-0"}
         (loc/tr :declared-pep)])]
     (->> kyc-profiles-and-pep-statuses
          (map-indexed
           (fn [idx {:keys [kyc-profile-id kyc-profile-label kyc-profile-type pep?]}]
             (let [last-item? (= idx last-item-index)
                   last-row-and-item? (and last-row? last-item?)]
               ^{:key (str kyc-profile-id)}
               [:tr
                [:td
                 {:class    (uu/cm "px-3 py-2 border border-t-0 border-r-0 first:border-l-0 text-[#007bff] cursor-pointer"
                                   (when last-row-and-item?
                                     "border-b-0"))
                  :col-span (if person? "1" "2")}
                 [:p
                  {:on-click #(open-entity! {:db/id       kyc-profile-id
                                             :entity/type kyc-profile-type})}
                  kyc-profile-label]]

                (when person?
                  [:td
                   {:class (uu/cm "px-3 py-2 border border-t-0 border-r-0 first:border-l-0"
                                  (when last-row-and-item?
                                    "border-b-0"))}
                   [pep-label-el
                    {:pep?                             pep?
                     :pep-or-rca-in-screening-service? pep-or-rca-in-screening-service?}]])]))))]))

(defn counterparty-diligences-rows
  [{:keys [counterparty-diligences-and-pep-statuses pep-or-rca-in-screening-service? person? last-row? open-entity!]}]
  (let [last-item-idx (-> counterparty-diligences-and-pep-statuses
                          count
                          dec)]
    [:<>
     [:tr
      [:td
       {:class    "px-3 py-2 bg-base-regular border border-t-0 border-r-0 first:border-l-0 font-semibold text-sm m-0"
        :col-span (if person? "1" "2")}
       (loc/tr :counterparty-diligence-name)]
      (when person?
        [:td
         {:class "px-3 py-2 bg-base-regular border border-t-0 border-r-0 first:border-l-0 font-semibold text-sm m-0"}
         (loc/tr :declared-pep)])]
     (->> counterparty-diligences-and-pep-statuses
          (map-indexed
           (fn [idx {:keys [counterparty-diligence-id counterparty-diligence-label
                            counterparty-diligence-type pep?]}]
             (let [last-item? (= idx last-item-idx)
                   last-row-and-item? (and last-row? last-item?)]
               ^{:key (str counterparty-diligence-id)}
               [:tr
                [:td
                 {:class    (uu/cm "px-3 py-2 border border-t-0 border-r-0 first:border-l-0 text-[#007bff] cursor-pointer"
                                   (when last-row-and-item?
                                     "border-b-0"))
                  :col-span (if person? "1" "2")}
                 [:p
                  {:on-click #(open-entity! {:db/id       counterparty-diligence-id
                                             :entity/type counterparty-diligence-type})}
                  counterparty-diligence-label]]

                (when person?
                  [:td
                   {:class (uu/cm "px-3 py-2 border border-t-0 border-r-0 first:border-l-0"
                                  (when last-row-and-item?
                                    "border-b-0"))}
                   [pep-label-el
                    {:pep?                             pep?
                     :pep-or-rca-in-screening-service? pep-or-rca-in-screening-service?}]])]))))]))

(defn pep-status-difference-alert
  [{:keys [screening-profile pep-or-rca-in-screening-service?]}]
  (let [screening-service-label (case (:screening-profile/screening-service screening-profile)
                                  :screening-service/risk-screen
                                  (loc/tr :riskscreen)
                                  (loc/tr :your-screening-service))
        alert-copy-text (if pep-or-rca-in-screening-service?
                          (loc/tr :pep-rca-mismatch-info-label-pep-or-rca-in-screening-service
                                  [screening-service-label])
                          (loc/tr :pep-rca-mismatch-info-label-not-pep-nor-rca-in-screening-service
                                  [screening-service-label]))]
    [:div
     {:class "rounded bg-warning-light border border-warning-regular w-full px-5 py-3 flex gap-2"}
     [:div
      [:i {:class "fal fa-exclamation-circle font-bold text-warning-light-text"}]]
     [:div
      {:class "flex flex-col gap-2"}
      [:p
       {:class "text-warning-light-text-accent font-bold"}
       (loc/tr :pep-rca-status-difference)]
      [:p
       {:class "text-warning-light-text font-medium text-sm m-0 text-pretty"}
       alert-copy-text]]]))

(defn view
  [{:keys [screening-profile
           show-kyc-data?
           show-counterparty-diligence-data?
           pep-or-rca-mismatch-data
           kyc-profiles-and-pep-statuses
           counterparty-diligences-and-pep-statuses
           open-entity!]
    :or   {open-entity! routing/open-entity}}]
  (let [person? (-> screening-profile
                    :screening-profile/type
                    (= :screening-profile-type/person))
        table-rows (model/create-table-rows
                    {:show-kyc-data?                           show-kyc-data?
                     :show-counterparty-diligence-data?        show-counterparty-diligence-data?
                     :screening-profile                        screening-profile
                     :kyc-profiles-and-pep-statuses            kyc-profiles-and-pep-statuses
                     :counterparty-diligences-and-pep-statuses counterparty-diligences-and-pep-statuses})
        table-row-count (count table-rows)
        pep-or-rca-in-screening-service? (:pep-or-rca-in-screening-service? pep-or-rca-mismatch-data)
        row-renderer-by-type {:header                  header-row
                              :info                    info-row
                              :key-value               key-value-row
                              :kyc-profiles            kyc-profiles-rows
                              :counterparty-diligences counterparty-diligences-rows}]
    [:<>
     (when (:mismatch? pep-or-rca-mismatch-data)
       [:<>
        [pep-status-difference-alert
         (merge
          pep-or-rca-mismatch-data
          {:screening-profile screening-profile})]
        [:div {:class "h-5 w-full min-h-5"}]])
     [:table
      {:class "w-full border-separate rounded border"}
      [:tbody
       (->> table-rows
            (map-indexed
             (fn [idx row]
               (let [row-key (str "row-" idx)
                     last-row? (= idx (dec table-row-count))
                     renderer (get row-renderer-by-type (:type row))
                     props (assoc row
                                  :last-row? last-row?
                                  :person? person?
                                  :open-entity! open-entity!
                                  :kyc-profiles-and-pep-statuses kyc-profiles-and-pep-statuses
                                  :counterparty-diligences-and-pep-statuses counterparty-diligences-and-pep-statuses
                                  :pep-or-rca-in-screening-service? pep-or-rca-in-screening-service?)]
                 (when renderer
                   ^{:key row-key}
                   [renderer props])))))]]]))
